// shared/ui/CatalogSelect.jsx  (presentacional: select MUI ligado a react-hook-form; opciones por props)
import React from 'react';
import { Controller } from 'react-hook-form';
import { selectFieldSx } from './autocompleteSx.js';
import { FormControl, FormHelperText, InputAdornment, InputLabel, MenuItem, Select } from '@mui/material';

// Opcionales: `placeholder` (texto gris cuando no hay valor), `startIcon` (clase fa-*), `error` (fieldError de RHF).
const CatalogSelect = ({
  id,
  name,
  control,
  label,
  options = [],
  disabled = false,
  emptyLabel = '— Sin selección —',
  onChangeExternal,
  placeholder,
  startIcon,
  error,
}) => {
  const shrink = !!(placeholder || startIcon) || undefined;
  return (
    <FormControl fullWidth style={{ marginTop: 3 }} error={!!error} sx={selectFieldSx}>
      <InputLabel id={`${id}-label`} shrink={shrink}>
        {label}
      </InputLabel>
      <Controller
        control={control}
        name={name}
        render={({ field: { onChange, onBlur, value } }) => (
          <Select
            labelId={`${id}-label`}
            id={id}
            label={label}
            disabled={disabled}
            displayEmpty={!!placeholder}
            notched={shrink}
            renderValue={
              placeholder
                ? selected => {
                    if (selected === '') return <span style={{ color: '#9aa0a6' }}>{placeholder}</span>;
                    const found = options.find(option => option.id === selected);
                    return found ? found.nombre : '';
                  }
                : undefined
            }
            startAdornment={
              startIcon ? (
                <InputAdornment position="start">
                  <i className={`fa ${startIcon}`} />
                </InputAdornment>
              ) : (
                undefined
              )
            }
            value={value === null || value === undefined ? '' : value}
            onBlur={onBlur}
            onChange={event => {
              const next = event.target.value === '' ? null : event.target.value;
              onChange(next);
              if (onChangeExternal) onChangeExternal(next);
            }}
            style={{ height: 44 }}>
            <MenuItem value="">
              <em>{emptyLabel}</em>
            </MenuItem>
            {options.map(option => (
              <MenuItem key={option.id} value={option.id}>
                {option.nombre}
              </MenuItem>
            ))}
          </Select>
        )}
      />
      {error && <FormHelperText>{error.message}</FormHelperText>}
    </FormControl>
  );
};

export default CatalogSelect;
